import { c as _c } from "react/compiler-runtime";
import { OptionCard } from "@justhome/react-ui";
import ToggleOptionCardGroup from "@modules/application/components/ToggleOptionCardGroup";
import clsx from "clsx";
import { useRouter } from "@lib/hooks/useRouter";
import { Control, Controller } from "react-hook-form";
import { FieldValues, FormFieldDefinition } from "./interfaces";
export interface ToggleButtonFieldProps<T extends FieldValues> {
  fieldDefinition: FormFieldDefinition<T>;
  control: Control<T>;
  onSubmit: any;
}
const ToggleButtonField = t0 => {
  const $ = _c(12);
  const {
    fieldDefinition,
    control,
    onSubmit
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== fieldDefinition.label || $[1] !== fieldDefinition.name || $[2] !== fieldDefinition.options || $[3] !== onSubmit || $[4] !== router) {
    t1 = t2 => {
      const {
        field
      } = t2;
      return <ToggleOptionCardGroup className="grid grid-cols-12 gap-2s" {...field} label={fieldDefinition.label}>{fieldDefinition.options?.map((option, index) => <OptionCard testId={`${fieldDefinition.name}-${option.value}`.toLocaleLowerCase()} className={clsx("col-span-12 m:col-start-auto", {
          "m:col-span-4": option.columns === 4,
          "m:col-span-12": option.columns === 12,
          "m:col-span-6": !option.columns
        })} image={option.image} key={index} value={option.value} onClick={e => {
          if (option.href) {
            e.preventDefault();
            router.push(option.href);
          } else {
            if (option.submit !== false) {
              setTimeout(() => onSubmit(), 400);
            }
          }
        }}>{option.label}</OptionCard>)}</ToggleOptionCardGroup>;
    };
    $[0] = fieldDefinition.label;
    $[1] = fieldDefinition.name;
    $[2] = fieldDefinition.options;
    $[3] = onSubmit;
    $[4] = router;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== control || $[7] !== fieldDefinition.defaultValue || $[8] !== fieldDefinition.name || $[9] !== fieldDefinition.rules || $[10] !== t1) {
    t2 = <Controller control={control} name={fieldDefinition.name} rules={fieldDefinition.rules} defaultValue={fieldDefinition.defaultValue} render={t1} />;
    $[6] = control;
    $[7] = fieldDefinition.defaultValue;
    $[8] = fieldDefinition.name;
    $[9] = fieldDefinition.rules;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
export default ToggleButtonField;